var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 offset-md-3"},_vm._l((_vm.images),function(image,index){return _c('div',{key:index,staticClass:"mb-4 text-center"})}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }